import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 0px 15px;
`

export const Message = styled.div`
    ${(props) => props.theme.typo.displayM}
    ${(props) => props.theme.fontWeight.medium}
`
